module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-bg dashbard-1",
    attrs: {
      "id": "page-wrapper"
    }
  }, [_c('ContentHeader', {
    on: {
      "showtip": _vm.opentip
    }
  }), _vm._v(" "), _c('ContentNav'), _vm._v(" "), _c('ContentBody'), _vm._v(" "), _c('ContentFooter')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7aee32ff","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/MainContent.vue
// module id = 1582
// module chunks = 0